'use server';

import { SessionService } from '@/contexts/authentication';
import { readOwnedAudioStory } from '@/contexts/audio-stories/services/readOwnedAudioStory';
import type { AudioStory } from '@/contexts/audio-stories/types';

/**
 * `null` = not found OR not yours (one answer, no existence leak) — the UI shows
 * the "unavailable" screen. A throw = a real failure — the UI offers retry.
 */
export async function getAudioStory(audioStoryId: string): Promise<AudioStory | null> {
  const familyId = await SessionService.getFamilyId();
  if (!familyId) return null;
  return readOwnedAudioStory(audioStoryId, familyId);
}
